import React, { Component } from "react";
import { pageTo, ajax, toast } from '@platform/api';
import { Dropdown, Menu } from '@platform/base';
// hyperLinkType = 0 时，hyperLinkName和hyperLinkUrl一定没值
// hyperLinkType = 1 时，hyperLinkUrl一定没值，浏览态显示name，编辑态显示名称，跳转是字段内容
// hyperLinkType = 2 时，有hyperLinkName显示名称，没有名称显示hyperLinkUrl，没有hyperLinkUrl显示字段内容；跳转hyperLinkUrl，没有hyperLinkUrl跳转字段内容

/**
 * hyperlinkflag 是否是超链接
 * hyperLinkType 1是字段内容 2是静态链接
 * hyperLinkUrl 是静态链接的地址
 * hyperLinkName 是显示名称
 */

import FormHyperlink from '../../Hyperlink/index.js';

const { IsURL, completionUrl } = FormHyperlink;
const { Item } = Menu;

class Hyperlink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            classId: '',
        };
    }

    render() {
        let { name, url, type, cellValue, itemType, onClick, locale, meta, tableId, currentId, colKey, datatype, searchKeyWord, style, ...other } = this.props,
            { options, classId } = this.state;
        let currentTableId = currentId || tableId;
        let content = name ?? (type === '2' ? url : cellValue?._display_);
        if (searchKeyWord && content.includes(searchKeyWord)) {
            let contentTmp = content.split(searchKeyWord);
            content = [];
            contentTmp.forEach((e, index) => {
                content.push(e);
                index !== contentTmp.length - 1 && content.push(<span key={index} className="high-light">{searchKeyWord}</span>);
            });
        }
        return <Dropdown
            trigger={['click']}
            overlay={options.length > 0 ? (
                <Menu className="hyperlink-overlay-wrapper">
                    {options.map((appPage, index) =>
                        (<Item key={index} onClick={() => {
                            this.setState({ options: [] });
                            pageTo.openTo(appPage.pageurl, {
                                appcode: appPage.parentcode,
                                id: cellValue.value,
                                pagecode: appPage.pagecode,
                                classid: classId,
                            });
                        }}>
                            {appPage.pagename}
                        </Item>),
                    )}
                </Menu>
            ) : ''}
        >
            <a
                style={style}
                {...other}
                onClick={e => {
                    e.stopPropagation();
                    if (type === '0' && itemType !== 'refer') {return;} // type=0时只有参照可以打开链接

                    // 字符型  没有外部链接 提示一下
                    if (datatype === '1' && !type) {
                        toast({
                            mark: 'hyperlink-wraning',
                            color: 'danger',
                            title: locale['page-form-0009'], //TODO
                            content: locale['page-invalid-hyperlink'],
                        });
                        return;
                    }

                    if (datatype === '1' && (type === '1' || type === '2')) {
                        let finalUrl = '';
                        if (type === '1') {
                            finalUrl = cellValue.value;
                        } else if (type === '2') {
                            finalUrl = url;
                        }

                        if (IsURL(finalUrl)) {
                            window.open(completionUrl(finalUrl), 'outside-link' + cellValue.value + (url ?? ''));
                        } else {
                            toast({
                                mark: 'hyperlink-wraning',
                                color: 'danger',
                                title: locale['page-form-0009'], //TODO
                                content: locale['page-invalid-hyperlink-url'],
                            });
                        }
                    } else {
                        ajax({
                            url: '/nccloud/platform/pub/gethyperlink.do',
                            method: 'post',
                            data: {
                                templetId: meta[currentTableId].pageid || meta.pageid,
                                areaCode: currentTableId,
                                code: colKey,
                                dataId: cellValue.value,
                            },
                            success: res => {
                                if (res.data) {
                                    let { appPage = {}, classid: classId = '' } = res.data;
                                    if (Array.isArray(appPage) && appPage.length > 1) {
                                        this.setState({ options: appPage, classId });
                                    } else {
                                        !Array.isArray(appPage) && (appPage = [appPage]);
                                        let { pageurl: pageUrl, parentcode: parentCode, pagecode: pageCode } = appPage[0] ?? {};
                                        pageUrl && pageTo.openTo(pageUrl, {
                                            appcode: parentCode,
                                            id: cellValue.value,
                                            pagecode: pageCode,
                                            classid: classId,
                                        });
                                    }
                                }
                            },
                        });
                    }
                }}
            >
                {content}
            </a>
        </Dropdown>;
    }
}
export default Hyperlink;